import React, { useEffect, useState } from 'react';
import {
    Badge,
    Button,
    Card,
    Col,
    Container,
    Row,
    Tab,
    Nav,
    Tabs,
    ListGroup,
    Spinner,
} from 'react-bootstrap';
import { useNavigate } from 'react-router';
import testCardImg from '../../Assets/Img/testCardImg.png';
import cardArrow from '../../Assets/Img/cardArrow.png';
import { useTranslation } from 'react-i18next';
import {
    useEyetestListMutation,
    useRecentEyetestListMutation,
} from '../Eyetest/eyetestApi';
import EyeTestImg from '../../Assets/Img/AdobeStock_6723704.jpeg';
import { useSelector } from 'react-redux';
import { ArrowRight } from 'lucide-react';
import { formatDate, frenchFormatDate } from '../../helper';
import { getSecureItem } from "../../utils/secureStorage";
const RecentTestCard = () => {
    const config = {
        eyeTestId: '',
        patientEmail: '',
        status: '',
        search: '',
        latestRecords: 1,
        pageSize: 50,
        pageNumber: 1,
        startDate: '',
        endDate: '',
        assigUnassigned: '',
    };
    const { t } = useTranslation();
    const user = getSecureItem('UserData');
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const eyetestData = useSelector((state) => state.eyetest);
    console.log(eyetestData, 'eyetestDataeyetestData');

    const [recentTestList] = useRecentEyetestListMutation();

    useEffect(() => {
        (async () => {
            if (loading) {
                const { data } = await recentTestList({
                    ...config,
                    patientEmail: user?.email,
                });
                setLoading(false);
            }
        })();
    }, [loading]);

    return (
        <Col md={6} className="mb-4">
            <Card
                className="hoverMintBg"
                style={{
                    height: '100%',
                    cursor: 'pointer',
                    pointerEvents: loading ? 'none' : 'auto',
                }}
                onClick={() =>
                    navigate('/eyetest/view', {
                        state: {
                            id: eyetestData?.recentListData[0]?.testId,
                            edit: false,
                            glass:
                                eyetestData?.recentListData[0]?.testType ===
                                'EyeGlasses'
                                    ? true
                                    : false,
                        },
                    })
                }
            >
                <Card.Header className="d-flex justify-content-between align-items-center bg-transparent">
                    <div className="d-flex gap-2">
                        <div className="d-flex align-items-center justify-content-center cardImgContainer">
                            <img src={testCardImg} style={{ height: '20px' }} />
                        </div>
                        <Card.Title className="mb-0 d-flex align-items-center">
                            {t('recentTestTitle')}
                        </Card.Title>
                    </div>
                    {eyetestData?.recentListData.length > 0 ? (
                        eyetestData?.recentListData[0]?.status === 'Approved' &&
                        eyetestData?.recentListData[0]?.needPrescription ? (
                            <Button
                                className="d-flex align-items-center justify-content-center"
                                onClick={() =>
                                    navigate('/prescription', {
                                        state: {
                                            id: eyetestData?.recentListData[0]
                                                ?.testId,
                                        },
                                    })
                                }
                            >
                                {t('lastPrecription')}{' '}
                                <ArrowRight className="ms-3" />
                            </Button>
                        ) : (
                            t('approvalPending')
                        )
                    ) : (
                        t('noTestCreated')
                    )}
                    {/* {eyetestData?.recentListData[0]?.status === "Approved" && eyetestData?.recentListData[0]?.needPrescription ? (
                        <Button className="d-flex align-items-center justify-content-center" onClick={() => navigate("/prescription", { state: { id: eyetestData?.recentListData[0]?.testId } })}>{t("lastPrecription")} <ArrowRight className="ms-3" /></Button>
                        // ) : t("approvalPending")}
                    ) : ""} */}

                    {/* <h2 className="display-6 fw-bold mb-0">{eyetestData?.recentListData?.length}</h2> */}
                </Card.Header>
                <Card.Body>
                    {loading ? (
                        <div className="text-center">
                            <Spinner animation="border" size="lg" role="status">
                                <span className="visually-hidden">
                                    Loading...
                                </span>
                            </Spinner>
                        </div>
                    ) : (
                        <ul className="recent_test_list">
                            {/* <li className="d-flex align-items-center justify-content-between"><span>Code</span><span style={{ color: "#0c111d" }}>{eyetestData?.recentListData[0]?.testUniqueCode}</span></li> */}
                            <li className="d-flex align-items-center justify-content-between">
                                <span>{t('type')}</span>

                                <span style={{ color: '#0c111d' }}>
                                    {eyetestData?.recentListData.length > 0
                                        ? eyetestData?.recentListData[0]
                                              ?.testType === 'EyeGlasses'
                                            ? t('glasses')
                                            : t('lenses')
                                        : 'N/A'}
                                </span>
                            </li>
                            <li className="d-flex align-items-center justify-content-between">
                                <span>{t('date')}</span>
                                <span style={{ color: '#0c111d' }}>
                                    {eyetestData?.recentListData.length > 0
                                        ? frenchFormatDate(
                                              eyetestData?.recentListData[0]
                                                  ?.createDate
                                          )
                                        : 'N/A'}
                                </span>
                            </li>
                        </ul>
                    )}

                    {/* <Card.Img variant="top" src={EyeTestImg} /> */}
                    {/* <div className="d-flex align-items-baseline">
                                                                    <h2 className="display-6 fw-bold mb-0">{totalEyetests}</h2> */}
                    {/* <span className="ms-2 text-muted">{t("testsDoneFromLastMonth")}</span> */}
                    {/* </div> */}
                    {/* <div style={{ height: "150px" }}>
                                                                <LineChart />
                                                            </div> */}
                </Card.Body>
            </Card>
        </Col>
    );
};
export default RecentTestCard;
